import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "./AdvancedBusiness.css";

import {
    APPLICATION_NAME,
    // TASK_TYPE_ACTIVITY,
    // FILES_TYPE_ACTIVITY,
    VISIT_TYPE_ACTIVITY,
    // PHONE_TYPE_ACTIVITY,
    STATUS_BUSINESS_GAIN,
    STATUS_BUSINESS_LOSS,
    // TRANSFER_TYPE_ACTIVITY,
    // HISTORIC_TYPE_ACTIVITY,
    STATUS_BUSINESS_PAUSED,
    // COME_BACK_TYPE_ACTIVITY,
    // ID_BRAND_USE_GROUP_2_ON_REASONS_FOR_LOSS,
    ADVANCED_BUSINESS_OPTION_SELECTED_COLUMNS,
    ADVANCED_BUSINESS_OPTION_SELECTED_FILTERS
} from "../../core/constants";
import {
    // formatedDateTime,
    // formatedMoneyBRAFromFloat,
    // formatedTime,
    // validTime,
    getOptionsSelectCheckedFormated,
} from "../../auxiliary/generalFunctions";

import Header from "../../components/CRM/Header";
import ButtonIcon from "../../components/general/ButtonIcon";
import MenuRight from "../../components/general/MenuRight";
// import TableEditAdvancedBusiness from "../../components/general/TableEditAdvancedBusiness";
import Check from "../../components/general/Check";
import Button from "../../components/general/Button";
import SelectMulti from "../../components/general/SelectMulti";
import InputGeneral from "../../components/general/InputGeneral";
import Loading from "../../components/general/Loading";

import BusinessController from "../../controllers/BusinessController";
// import BusinessReasonsForLossController from "../../controllers/BusinessReasonsForLossController";
// import CampaignController from "../../controllers/CampaignController";
// import MidiaOriginController from "../../controllers/MidiaOriginController";
// import ProspectionTeamHierarchyController from "../../controllers/ProspectionTeamHierarchyController";
import UserController from "../../controllers/UserController";
import ServiceController from "../../controllers/ServiceController";
import TableEditReceivables from "../../components/general/TableEditReceivables";

const serviceController = new ServiceController();
// const businessReasonsForLossController = new BusinessReasonsForLossController();
// const campaignController = new CampaignController();
// const midiaOriginController = new MidiaOriginController();
// const prospectionTeamHierarchyController = new ProspectionTeamHierarchyController();
const userController = new UserController();
const businessController = new BusinessController();

const initialState = {
    services: [],
    columns: [],

    loading: false,

    isMenuOpen: false,
    menuViewOptionSelected: ADVANCED_BUSINESS_OPTION_SELECTED_FILTERS,
    currentPage: 1,
    totalPages: 0,
    countTotalBusiness: 0,

    // starts filters

    choosenTermFilter: {
        value: null,
        name: null
    },
    choosenTypeService: {
        value: null,
        name: null
    }, 
    optionsCompanyUnits: [],
    optionsTypesServices: [],
    optionsTypesDebts: [],
    withGroupBy: true
    // ends filters
}

class AdvancedBusiness extends Component
{
    state = { ...initialState }

    componentDidMount = async () =>
    {
        document.title = `${APPLICATION_NAME} - Contas à Receber`;
        await this.getColumns();
        if (this.props.permissions.hasPermissionsLoaded) 
        {
            await this.getFilters();
            await this.verifyParamsURL();
        }
    }

    componentDidUpdate = async (prevProps, prevState) =>
    {
        if (prevProps.permissions.hasPermissionsLoaded !== this.props.permissions.hasPermissionsLoaded) 
		{
			if (!this.props.permissions.receivables.toView) { this.props.history.push(`/activities`); }
            await this.getFilters();
            await this.verifyParamsURL();
		}
    }

    applyFilters = async () =>
    {
        // INFORMATION: Don't remove the follow lines...
        // const rowHeight = 32;
        // const { height } = getWindowDimensions();
        // const NUMBER_ROWS_PER_PAGE = Math.ceil(((height - 56 - 65 - rowHeight) / rowHeight) * 1.5);

        let filters = {
            USER_ID: this.props.user.PER_ID_USER_ERP,
            PAGINATE: true,
            NUMBER_ROWS_PER_PAGE: (1000 * this.state.currentPage),
            CURRENT_PAGE: this.state.currentPage,
        };

        const choosenCompanyUnit = this.state.optionsCompanyUnits.filter(unit => unit.checked);
        const choosenTypeService = this.state.optionsTypesServices.filter(unit => unit.checked);

        const term = this.state.term;
        const termFilter = this.state.choosenTermFilter.value;
        const companyUnit = choosenCompanyUnit;
        const typeService = choosenTypeService;

        term !== "" && (filters.term = term);
        termFilter !== null && (filters.termFilter = termFilter);
        companyUnit && (filters.companyUnit = companyUnit);
        typeService && (filters.typeService = typeService);

        await this.getReceivables(filters);
    }

    getReceivables = async (filters) =>
    {
        await this.setState({ loading: true });

        const result = await serviceController.receivables(filters);

        if (!result.status) { return; }

        const data = result.data.data;
        let rows = [];

        for (const debt of data) 
        {
            rows.push({
                idService: debt.idService,
                office: debt.office,
                clientName: debt.clientName,
                debtValue: debt.debtValue,
                debtNumber: debt.debtNumber,
                typeService: debt.typeService,
                dueDate: debt.dueDate,
            });
        }

        const countTotalBusiness = result.data._paginate.total_rows;
        const totalPages = result.data._paginate.total_pages;

        if (this.state.currentPage > 1)
        {
            rows = [
                ...this.state.services,
                ...rows
            ]
        }

        await this.setState({services: rows, countTotalBusiness, totalPages, loading: false});
    }

    getColumns = async () =>
    {
        const columnsInLocalStorage = JSON.parse(localStorage.getItem("CRM_SEMPNET_RECEIVABLES_COLUMNS"));
        let columns = [
            {
                name: "ID",
                slug: "ID_SERVICE",
                visible: true
            },
            {
                name: "Unidade",
                slug: "OFFICE",
                visible: true
            },
            {
                name: "Nome do Cliente",
                slug: "CLIENT_NAME",
                visible: true
            },
            {
                name: "N. Parcela",
                slug: "DEBT_NUMBER",
                visible: true
            },
            {
                name: "Valor R$",
                slug: "DEBT_VALUE",
                visible: true
            },
            {
                name: "Vencimento",
                slug: "DUE_DATE",
                visible: true
            },
            {
                name: "Tipo de Serviço",
                slug: "TYPE_SERVICE",
                visible: true
            },
            // {
            //     name: "Dias de atraso",
            //     slug: "ID_SERVICE_ERP",
            //     visible: false
            // }
        ];
        if (columnsInLocalStorage) 
        {
            const allVisibleColumns = columnsInLocalStorage.filter(c => c.visible).map(c => c.slug);
            columns = columns.map(c => allVisibleColumns.includes(c.slug) ? {...c, visible: true} : {...c, visible: false});
        }
        await this.setState({columns});
    }

    getFilters = async () =>
    {
        // const user = await userController.getById(this.props.user.PER_ID);

        const 
            [
                resultCompanyUnit,
                resultBusinessServices
            ] 
            = await Promise.all(
                [
                    userController.getOwnersForUserOnAccess(this.props.user.PER_ID),
                    businessController.getBusinessServices()
                ]
            );

        const optionsCompanyUnits = [];
        const allUnits = resultCompanyUnit.data.data.filter(u => u.UNT_STATUS === 1);
            
        for (const unit of allUnits) 
        {
            optionsCompanyUnits.push({
                name: unit.UNT_NAME,
                value: unit.UNT_ID_COMPANY_UNIT_ERP,
                checked: allUnits.length === 1 ? true : false
            });
        }

        let optionsTypesServices = [];
        for (const service of resultBusinessServices.data) 
        {
            if (service.BUP_ID_FINANCIAL_SERVICE)
            {
                optionsTypesServices.push(
                    {
                        name: service.BUP_NAME,
                        erp: service.BUP_ID_SERVICE_ERP,
                        value: service.BUP_ID,
                        checked: false
                    }
                );
            }
        }

        await this.setState({
            optionsCompanyUnits,
            optionsTypesServices
        });
    }

    getMenuTitle = () => 
    {
        switch(this.state.menuViewOptionSelected)
        {
            case ADVANCED_BUSINESS_OPTION_SELECTED_COLUMNS:
                return "Configurar colunas";
            case ADVANCED_BUSINESS_OPTION_SELECTED_FILTERS:
                return "Filtros";
            default:
                return "";
        }
    }

    getShowedupName = showedup =>
    {
        switch(showedup)
        {
            case 1:
                return "Compareceu";
            case 2:
                return "Não compareceu";
            default: 
                return "";
        }
    }

    getShowedupIcon = showedup =>
    {
        switch(showedup)
        {
            case 1:
            case 3:
                return "far fa-user-check";
            case 2:
                return "far fa-user-slash";
            default: 
                return "";
        }
    }

    getStatusName = status => 
    {
        switch(status)
        {
            case STATUS_BUSINESS_GAIN:
                return "Ganho";
            case STATUS_BUSINESS_LOSS:
                return "Perdido";
            case STATUS_BUSINESS_PAUSED:
                return "Pausado";
            default:
                return "Em andamento";
        }
    }

    getStatusIcon = status =>
    {
        switch (status) 
        {
            case STATUS_BUSINESS_GAIN:
                return "fas fa-trophy-alt";
            case STATUS_BUSINESS_LOSS:
                return "fas fa-do-not-enter";
            case STATUS_BUSINESS_PAUSED:
                return "far fa-pause-circle";
            default:
                return "far fa-running";
        }
    }

    getStepName = step =>
    {
        switch(step) 
        {
            case 1:
                return "Lead";
            case 2:
                return "Primeiro Contato";
            case 3:
                return "Em Atendimento";
            case 4:
                return "Visita Agendada";
            case 5:
                return "Reagendar";
            default:
                return "";
        }
    }

    handleChangeColumns = async (slug) =>
    {
        const updatedColumns = this.state.columns.map(c => c.slug === slug ? {...c, visible: !c.visible} : c);
        await this.setState({ columns: updatedColumns });
        localStorage.setItem("CRM_SEMPNET_RECEIVABLES_COLUMNS", JSON.stringify(updatedColumns));
    }

    verifyParamsURL = async () =>
    {
        const query = new URLSearchParams(this.props.location.search);
        const type = query.get('type');

        let activityCreatedBy = query.get('activity_created_by');
        let companyUnit = query.get('company_unit');
        const groupBy = query.get('group_by');
        const onlyBusinessWithAttendant = query.get('only_business_with_attendant');
        const onlyBusinessWithOwner = query.get('only_business_with_owner');
        const createDateStart = query.get('create_date_start');
        const createDateEnds = query.get('create_date_ends');
        const midiaOrigin = query.get('midia_origin');
        const activityDateCreatedStart = query.get('activity_create_date_start');
        const activityDateCreatedEnds = query.get('activity_create_date_ends');
        const activityDateStart = query.get('activity_date_start');
        const activityDateEnds = query.get('activity_date_ends');
        const statusDateStart = query.get('status_date_start');
        const statusDateEnds = query.get('status_date_ends');
        let prospectionOwners = query.get('prospection_owner');
        const reasonForLoss = query.get('reason_for_loss');
        let coordinator = query.get('coordinator');
        let showedup = query.get('showedup');
        let status = query.get('status');
        let supervisor = query.get('supervisor');
        const timeStart = query.get('time_start');
        const timeEnds = query.get('time_ends');
        let typeActivity = query.get('type_activity');
        const typePeriodVisit = query.get('type_visit_period');
        let withActivities = query.get('with_activities');

        let filtered = false;

        if (type)
        {
            filtered = true;
            switch(type)
            {
                case "all":
                    const optionsReasonsForLossAll = this.state.optionsReasonsForLoss.map(r => ({ ...r, checked: ![3,21,22].includes(r.value) }));
                    await this.setState({ 
                        optionsReasonsForLoss: optionsReasonsForLossAll 
                    });
                    break;

                case "in_progress_attendance":
                    const optionsStatusInProgressAttendance = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === "OPEN" }));
                    const optionsOwnersInProgressAttendance = this.state.optionsOwnersFiltered.map(o => ({ ...o, checked: o.value === 0 }));
                    const optionsProspectionOwnersInProgressAttendance = this.state.optionsProspectionOwners.map(p => ({ ...p, checked: p.value !== 0 }));
                    await this.setState({ 
                        optionsStatus: optionsStatusInProgressAttendance, 
                        optionsOwnersFiltered: optionsOwnersInProgressAttendance, 
                        optionsProspectionOwners: optionsProspectionOwnersInProgressAttendance 
                    });
                    break;

                case "loss":
                    const optionsStatusLoss = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === STATUS_BUSINESS_LOSS }));
                    const optionsReasonsForLossLoss = this.state.optionsReasonsForLoss.map(r => ({ ...r, checked: ![3,7,8,12,13,18,19,20,21,22,23].includes(r.value) }));
                    await this.setState({ 
                        optionsStatus: optionsStatusLoss, 
                        optionsReasonsForLoss: optionsReasonsForLossLoss 
                    });
                    break;

                case "not_applicable":
                    const optionsReasonsForLossNotApplicable = this.state.optionsReasonsForLoss.map(r => ({ ...r, checked: [7,8,12,13,18,19,20,23].includes(r.value) }));
                    const optionsStatusNotApplicable = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === STATUS_BUSINESS_LOSS }));
                    await this.setState({ 
                        optionsStatus: optionsStatusNotApplicable, 
                        optionsReasonsForLoss: optionsReasonsForLossNotApplicable 
                    });
                    break;

                case "discarded":
                    const optionsReasonsForLossDiscarded = this.state.optionsReasonsForLoss.map(r => ({ ...r, checked: [3,21,22].includes(r.value) }));
                    await this.setState({ 
                        optionsReasonsForLoss: optionsReasonsForLossDiscarded 
                    });
                    break;

                case "paused":
                    const optionsStatusPaused = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === STATUS_BUSINESS_PAUSED }));
                    await this.setState({ optionsStatus: optionsStatusPaused });
                    break;

                case "scheduled":
                    const optionsTypeActivityScheduled = this.state.optionsTypeActivity.map(t => ({ ...t, checked: t.value === VISIT_TYPE_ACTIVITY }));
                    await this.setState({ onlyBusinessWithActivities: true, optionsTypeActivity: optionsTypeActivityScheduled });
                    break;

                case "gain_units":
                    const optionsStatusGainUnits = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === STATUS_BUSINESS_GAIN}));
                    await this.setState({ onlyBusinessWithoutVisit: true, optionsStatus: optionsStatusGainUnits });
                    break;

                case "without_attendance":
                    const optionsStatusWithoutAttendance = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === "OPEN" }));
                    const optionsProspectionOwnersWithoutAttendance = this.state.optionsProspectionOwners.map(p => ({ ...p, checked: p.value === 0 }));
                    await this.setState({ 
                        optionsStatus: optionsStatusWithoutAttendance, 
                        optionsProspectionOwners: optionsProspectionOwnersWithoutAttendance 
                    });
                    break;

                case "showed_up":
                    const optionsShowedup = this.state.optionsShowedup.map(s => ({ ...s, checked: s.value === 1 }));
                    const optionsTypeActivityShowedup = this.state.optionsTypeActivity.map(t => ({ ...t, checked: t.value === VISIT_TYPE_ACTIVITY }));
                    await this.setState({ 
                        optionsShowedup,
                        onlyBusinessWithActivities: true,
                        optionsTypeActivity: optionsTypeActivityShowedup
                    });
                    break;

                case "no_showed_up":
                    const optionsNoShowedup = this.state.optionsShowedup.map(s => ({ ...s, checked: s.value === 2 }));
                    const optionsTypeActivityNoShowedup = this.state.optionsTypeActivity.map(t => ({ ...t, checked: t.value === VISIT_TYPE_ACTIVITY }));
                    await this.setState({ 
                        optionsShowedup: optionsNoShowedup,
                        onlyBusinessWithActivities: true,
                        optionsTypeActivity: optionsTypeActivityNoShowedup
                    });
                    break;

                case "showed_up_or_no_showed_up":
                    const optionsShowedupOrNoShowedup = this.state.optionsShowedup.map(s => ({ ...s, checked: true }));
                    const optionsTypeActivityShowedupOrNoShowedup = this.state.optionsTypeActivity.map(t => ({ ...t, checked: t.value === VISIT_TYPE_ACTIVITY }));
                    await this.setState({ 
                        optionsShowedup: optionsShowedupOrNoShowedup,
                        onlyBusinessWithActivities: true,
                        optionsTypeActivity: optionsTypeActivityShowedupOrNoShowedup
                    });
                    break;

                case "business_with_activities":
                    withActivities = 1;
                    break;

                case "business_with_activities_and_without_attendance":
                    withActivities = 1;
                    let optionsStatusWithoutAttendanceAndWithActivites = this.state.optionsStatus.map(s => ({ ...s, checked: s.value === "OPEN" }));
                    let optionsProspectionOwnersWithoutAttendanceAndWithActivites = this.state.optionsProspectionOwners.map(p => ({ ...p, checked: p.value === 0 }));
                    await this.setState({ 
                        optionsStatus: optionsStatusWithoutAttendanceAndWithActivites, 
                        optionsProspectionOwners: optionsProspectionOwnersWithoutAttendanceAndWithActivites 
                    });
                    break;

                default:
                    break;
            }
        }

        if (activityCreatedBy)
        {
            filtered = true;
            activityCreatedBy = activityCreatedBy.split(",").map(u => parseInt(u));

            let optionsActivityCreatedBy = [];
            for (const po of this.state.optionsActivityCreatedBy)
            {
                optionsActivityCreatedBy.push({
                    ...po,
                    checked: activityCreatedBy.includes(po.value)
                });
            }

            await this.setState({
                optionsActivityCreatedBy
            });
        }

        if (activityDateCreatedStart)
        {
            filtered = true;
            await this.setState({filterActivityDateCreatedStart: activityDateCreatedStart});
        }

        if (activityDateCreatedEnds)
        {
            filtered = true;
            await this.setState({filterActivityDateCreatedEnds: activityDateCreatedEnds});
        }

        if (activityDateStart)
        {
            filtered = true;
            await this.setState({filterActivityDateStart: activityDateStart});
        }

        if (activityDateEnds)
        {
            filtered = true;
            await this.setState({filterActivityDateEnds: activityDateEnds});
        }

        if (companyUnit)
        {
            filtered = true;
            companyUnit = companyUnit.split(",").map(u => parseInt(u));
            let optionsCompanyUnits = [];

            for (const unit of this.state.optionsCompanyUnits)
            {
                optionsCompanyUnits.push(
                    {
                        ...unit,
                        checked: companyUnit.includes(unit.value)
                    }
                );
            }

            await this.setState({optionsCompanyUnits});
        }

        if (createDateStart)
        {
            filtered = true;
            await this.setState({filterCreateDateStart: createDateStart});
        }

        if (createDateEnds)
        {
            filtered = true;
            await this.setState({filterCreateDateEnds: createDateEnds});
        }

        if (groupBy)
        {
            filtered = true;
            await this.setState({withGroupBy: parseInt(groupBy) === 1 ? true : false});
        }

        if (midiaOrigin)
        {
            filtered = true;
            const optionsMidiaOriginGeneral = this.state.optionsMidiaOrigin.map(m => ({...m, checked: m.value === parseInt(midiaOrigin)}));
            await this.setState({optionsMidiaOrigin: optionsMidiaOriginGeneral});
        }

        if (onlyBusinessWithAttendant)
        {
            filtered = true;
            await this.setState({onlyBusinessWithAttendant: parseInt(onlyBusinessWithAttendant) === 1 ? true : false});
        }

        if (onlyBusinessWithOwner)
        {
            filtered = true;
            await this.setState({onlyBusinessWithOwner: parseInt(onlyBusinessWithOwner) === 1 ? true : false});
        }

        if (prospectionOwners)
        {
            filtered = true;
            prospectionOwners = prospectionOwners.split(",").map(u => parseInt(u));

            let optionsProspectionOwners = [];
            for (const po of this.state.optionsProspectionOwners)
            {
                optionsProspectionOwners.push({
                    ...po,
                    checked: prospectionOwners.includes(po.value)
                });
            }

            await this.setState({
                optionsProspectionOwners
            });
        }

        if (reasonForLoss)
        {
            filtered = true;
            const optionsReasonsForLoss = this.state.optionsReasonsForLoss.map(r => ({ ...r, checked: r.value === parseInt(reasonForLoss) }));
            await this.setState({optionsReasonsForLoss});
        }

        if (showedup)
        {
            filtered = true;
            showedup = showedup.split(",").map(u => parseInt(u));

            let optionsShowedup = [];
            for (const s of this.state.optionsShowedup)
            {
                optionsShowedup.push({
                    ...s,
                    checked: showedup.includes(s.value)
                });
            }

            await this.setState({
                optionsShowedup
            });
        }

        if (status)
        {
            filtered = true;
            status = status.split(",").map(s => s.toUpperCase());

            let optionsStatus = [];
            for (const s of this.state.optionsStatus)
            {
                optionsStatus.push({
                    ...s,
                    checked: status.includes(s.value)
                });
            }

            await this.setState({
                optionsStatus
            });
        }

        if (statusDateStart)
        {
            filtered = true;
            await this.setState({filterStatusDateStart: statusDateStart});
        }

        if (statusDateEnds)
        {
            filtered = true;
            await this.setState({filterStatusDateEnds: statusDateEnds});
        }

        if (coordinator)
        {
            filtered = true;
            coordinator = coordinator.split(",").map(u => parseInt(u));

            let optionsCoordinators = [];
            for (const c of this.state.optionsCoordinators)
            {
                optionsCoordinators.push({
                    ...c,
                    checked: coordinator.includes(c.value)
                });
            }

            await this.setState({
                optionsCoordinators
            });
        }

        if (supervisor)
        {
            filtered = true;
            supervisor = supervisor.split(",").map(u => parseInt(u));

            let optionsSupervisors = [];
            for (const s of this.state.optionsSupervisors)
            {
                optionsSupervisors.push({
                    ...s,
                    checked: supervisor.includes(s.value)
                });
            }

            await this.setState({
                optionsSupervisors
            });
        }

        if (timeStart)
        {
            filtered = true;
            await this.setState({
                filterCreateTimeStart: timeStart,
                filterStatusTimeStart: timeStart,
                filterActivityTimeCreatedStart: timeStart,
                filterActivityTimeStart: timeStart
            });
        }

        if (timeEnds)
        {
            filtered = true;
            await this.setState({
                filterCreateTimeEnds: timeEnds,
                filterStatusTimeEnds: timeEnds,
                filterActivityTimeCreatedEnds: timeEnds,
                filterActivityTimeEnds: timeEnds
            });
        }

        if (typeActivity)
        {
            filtered = true;
            typeActivity = typeActivity.split(",").map(t => t.toUpperCase());

            let optionsTypeActivity = [];
            for (const t of this.state.optionsTypeActivity)
            {
                optionsTypeActivity.push({
                    ...t,
                    checked: typeActivity.includes(t.value)
                });
            }

            await this.setState({
                optionsTypeActivity
            });
        }

        if (typePeriodVisit)
        {
            filtered = true;
            const optionsTypeVisitBusiness = this.state.optionsTypeVisitBusiness.map(t => ({...t, checked: t.value === typePeriodVisit.toUpperCase()}));
            await this.setState({optionsTypeVisitBusiness});
        }

        if (withActivities)
        {
            filtered = true;
            await this.setState({onlyBusinessWithActivities: parseInt(withActivities) === 1 ? true : false});
        }

        if (filtered) {
            await this.applyFilters();
        }
    }

    render()
    {
        return (
            <div className="advancedBusiness">
                {
                    this.state.loading &&
                    <div className="advancedBusinessLoading">
                        <Loading loading={this.state.loading} />
                    </div>
                }
                <MenuRight
                    title={this.getMenuTitle()} 
                    isOpen={this.state.isMenuOpen} 
                    onCloseMenu={() => this.setState({
                        isMenuOpen: !this.state.isMenuOpen
                    })}
                >
                    {
                        this.state.menuViewOptionSelected === ADVANCED_BUSINESS_OPTION_SELECTED_FILTERS && 
                        <Fragment>
                            <div className="row no-gutters">
                                <div className="col-12 mb-2 pr-1 pl-1">
                                    <SelectMulti
                                        label="Unidade(s)"
                                        default={{name: getOptionsSelectCheckedFormated(this.state.optionsCompanyUnits, "[Todas Unidades]", "unidades")}}
                                        options={this.state.optionsCompanyUnits} 
                                        onChange={async (choosenCompanyUnit) => {
                                            await this.setState({choosenCompanyUnit});
                                        }}
                                        withFieldSearch
                                    />
                                </div>
                            </div>
                            <div className="row no-gutters">
                                <div className="col-12 mt-2 mb-2 pr-1 pl-1">
                                    <SelectMulti
                                        label="Tipos de serviço"
                                        default={{name: getOptionsSelectCheckedFormated(this.state.optionsTypesServices, "[Todas Tipos]", "tipos")}}
                                        options={this.state.optionsTypesServices} 
                                        onChange={(optionsTypesServices) => this.setState({optionsTypesServices})}
                                        withFieldSearch
                                    />
                                </div>
                            </div>
                            <div className="row no-gutters mt-2 mb-2 pr-1 pl-1">
                                <div className="col-12 columnOwnerForm">
                                    <InputGeneral
                                        label="Nome/Telefone do cliente"
                                        value={this.state.filterSearchClient}
                                        onChange={e => this.setState({filterSearchClient: e.target.value})}
                                    />
                                </div>
                            </div>
                            <div className="row no-gutters">
                                <div className="col-12 mt-3 mb-2 pr-1 pl-1">
                                    <Button
                                        name="aplicar filtros"
                                        classaditional="buttonApplyFiltersAdvancedBusiness"
                                        onClick={async () => {
                                            await this.setState({
                                                isMenuOpen: !this.state.isMenuOpen,
                                                currentPage: 1
                                            });
                                            this.applyFilters()
                                        }}
                                    />
                                </div>
                            </div>
                        </Fragment>
                    }
                    {
                        this.state.menuViewOptionSelected === ADVANCED_BUSINESS_OPTION_SELECTED_COLUMNS &&
                        <div className="row no-gutters">
                        {
                            this.state.columns.map((column, i) => (
                                <div key={i} className="col-12 mt-2 mb-2">
                                    <Check 
                                        name={column.name} 
                                        checked={column.visible} 
                                        onClick={() => this.handleChangeColumns(column.slug)} 
                                    />
                                </div>
                            ))
                        }
                        </div>
                    }
                </MenuRight>
                <Header title="Contas A Receber" classaditional="headerAdvancedBusiness"/>
                <div className="warningAdvancedBusiness d-flex d-md-none">
                    <span>Opsssss, alguns recursos foram desativados para dispositivos móveis.</span>
                </div>
                <div className="row no-gutters align-items-center containerHeaderAdvancedBusiness">
                    <div className="col">
                        <ButtonIcon
                            icon="far fa-bars"
                            classaditional="buttonNavigationHeaderAdvancedBusiness active" 
                        />
                    </div>
                    <div className="col">
                        {this.state.countTotalBusiness} negócio(s) encontrado(s)
                    </div>
                    <div className="ml-auto">
                        <Button
                            icon="fas fa-columns"
                            name="&nbsp;&nbsp;Colunas"
                            classaditional="buttonHeaderAdvancedBusiness"
                            onClick={() => {
                                this.setState({
                                    isMenuOpen: !this.state.isMenuOpen,
                                    menuViewOptionSelected: ADVANCED_BUSINESS_OPTION_SELECTED_COLUMNS
                                });
                            }}
                        />
                    </div>
                    <div>
                        <Button
                            icon="fas fa-filter"
                            name="&nbsp;&nbsp;Filtros"
                            classaditional="buttonHeaderAdvancedBusiness"
                            onClick={() => {
                                this.setState({
                                    isMenuOpen: !this.state.isMenuOpen,
                                    menuViewOptionSelected: ADVANCED_BUSINESS_OPTION_SELECTED_FILTERS
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="containerListAdvancedBusiness">
                    <TableEditReceivables
                        data={this.state.services} 
                        columns={this.state.columns} 
                        onScroll={async () => {
                            console.log("scrolling...");
                            if (this.state.currentPage === this.state.totalPages) { return; }
                            const nextPage = this.state.currentPage + 1;
                            await this.setState({currentPage: nextPage});
                            await this.applyFilters();
                        }}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) 
{
    const permissions = state.permissions;
    const { user } = state.auth;

    return {
        permissions,
        user
    }
}

function mapDispatchToProps (dispatch)
{
    return {
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvancedBusiness));